/*
  Envio ao Zé Spot (rota /e/produto), pelo pocket que a página já carrega.

  O DEX manda ao Mixpanel por `window.mixpanel.track`, sem o POCKET, então o envio que o
  pocket faz sozinho não vê estes eventos. Este módulo entrega ao `POCKET.zespot` só o que
  está em `ZESPOT_ACEITOS`: hoje o `Exercise Answered`, que entra na régua de consumo do
  aluno ativo (DAU/WAU/MAU) do Data & Growth (ATV-202610011533).

  Regras:
  - `userEmail` e `userName` nunca saem daqui (a porta também os remove);
  - `application: 'dex'` marca a origem no próprio evento, e `origem: 'dex'` faz o mesmo
    pelo pocket 1.16.14+;
  - o pocket é configurado sempre que ainda não aceita o evento, e não uma vez por página: a
    tela de login (views/Login.vue) recarrega o `pocket.latest.js`, e o `window.POCKET` novo
    nasce com a lista padrão (só os três lesson), que descartaria o evento em silêncio;
  - `prepararZeSpot(opcoes)` guarda o que o app pediu no boot (o dex-web pede
    `pageview: true`), e isso vale para todo pocket da página, inclusive o recarregado;
  - telemetria nunca derruba a página: qualquer falha é engolida.
*/

export const ZESPOT_ACEITOS = ["exercise answered"];

const SEM_DADO_PESSOAL = ["userEmail", "userName"];

export interface OpcoesDoZeSpot {
  /*
    Opt-in de page view do pocket: `page_view` na carga e a cada troca de rota. Pocket anterior
    ao opt-in ignora a chave, sem efeito.
  */
  pageview?: boolean;
}

let opcoesDaPagina: OpcoesDoZeSpot = {};

function zespotDaPagina(): any {
  const pocket = typeof window !== "undefined" ? (window as any).POCKET : null;
  const zespot = pocket ? pocket.zespot : null;
  return zespot && typeof zespot.enviar === "function" ? zespot : null;
}

function configurar(zespot: any): void {
  if (typeof zespot.configurar !== "function") return;
  const config: any = { aceitos: ZESPOT_ACEITOS.slice(), origem: "dex" };
  if (opcoesDaPagina.pageview) config.pageview = true;
  zespot.configurar(config);
}

function jaAceita(zespot: any, eventName: string): boolean {
  return typeof zespot.aceita === "function" && zespot.aceita(eventName) === true;
}

/*
  O app chama no boot, depois de o pocket rodar, e a tela de login chama de novo, depois de
  recarregar o pocket. As opções ficam guardadas: valem também para um pocket que só chegue
  depois, configurado no primeiro evento.
*/
export function prepararZeSpot(opcoes?: OpcoesDoZeSpot): boolean {
  try {
    if (opcoes) opcoesDaPagina = { ...opcoesDaPagina, ...opcoes };
    const zespot = zespotDaPagina();
    if (!zespot) return false;
    configurar(zespot);
    return true;
  } catch (e) {
    return false;
  }
}

export function enviarAoZeSpot(eventName: string, data: any): boolean {
  try {
    if (ZESPOT_ACEITOS.indexOf(String(eventName).trim().toLowerCase()) < 0) return false;
    const zespot = zespotDaPagina();
    if (!zespot) return false;
    if (!jaAceita(zespot, eventName)) configurar(zespot);
    const props: any = { application: "dex" };
    Object.keys(data || {}).forEach((k) => {
      if (SEM_DADO_PESSOAL.indexOf(k) < 0) props[k] = data[k];
    });
    zespot.enviar(eventName, props, { userId: props.userId });
    return true;
  } catch (e) {
    return false;
  }
}

/** Só para os testes: cada teste é uma página nova. */
export function reiniciarParaTeste(): void {
  opcoesDaPagina = {};
}
